import { useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import { NavBar } from './Components/Navbar/Navbar';
import Management from './Pages/ManagementPage/ManagementPage';
import Construction from './Pages/ConstructionPage/ConstructionPage';
import Projects from './Pages/ProjectsPage/ProjectsPage';
import About from "./Pages/AboutPage/AboutPage";
import Home from './Pages/HomePage/HomePage';
import ContactForm from './Pages/ContactPage/ContactPage';
import Privacy from "./Pages/PrivacyPage/PrivacyPage";
import './Styles/App.scss';
import Footer from './Components/Footer/Footer';
import { ParallaxProvider } from "react-scroll-parallax";
import Careers from "./Pages/CareersPage/CareersPage";
import Terms from "./Pages/TermsPage/terms";
import { ScrollToTop } from "./Components/Functions/ScrollToTop";
import NotFoundPage from "./Pages/NotFoundPage/NotFoundPage";
import FormSubmittedPage from "./Pages/ContactPage/FormSubmittedPage";
import CookieBanner from "./Components/CookieBanner/CookieBanner";
import Charlemagne from "./Pages/ProjectsPage/Projects/OVIV/Charlemagne";
import LVGFP from "./Pages/ProjectsPage/Projects/LeVivo/GreenfieldPark/LeVivoGreenfieldPark";
import LeVivoLongueuil1 from "./Pages/ProjectsPage/Projects/LeVivo/Longueuil1/LeVivoLongueil1";
import Headquarters from "./Pages/ProjectsPage/Projects/Headquarters/hq";
import Lenis from 'lenis';


function App() {

  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('bootstrap/dist/css/bootstrap.min.css');
    }
  }, []);


  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true
    })
  
    function raf(time: number) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
  
    requestAnimationFrame(raf)
  
    return () => {
      lenis.destroy()
    }
  }, [])

  /*
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate video loading delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // Set the duration of your splash screen

    return () => clearTimeout(timer); // Clean up timer on unmount
  }, []);
  
  
  if (isLoading) {
    return <SplashScreen />;
  }
  
  else{
    */
  
    return (
      <ParallaxProvider>
        <ScrollToTop/>
        <NavBar/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/construction' element={<Construction/>}/>
          <Route path='/gestion' element={<Management/>}/>
          <Route path='/projets' element={<Projects/>}/>
          <Route path='/histoire' element={<About/>}/>
          <Route path='/nousrejoindre' element={<ContactForm/>}/>
          <Route path='/nousrejoindre/merci' element={<FormSubmittedPage/>}/>
          <Route path='/carrieres' element={<Careers/>}/>
          <Route path='/avis-legal' element={<Terms/>}/>
          <Route path='/politique-confidentialite' element={<Privacy/>}/>
          <Route path="*" element={<NotFoundPage />} />
          
          {/*projects*/}
          <Route path='/projets/quartier-oviv' element={<Charlemagne/>}/>
          <Route path='/projets/levivo/greenfield-park' element={<LVGFP/>}/>
          <Route path='/projets/levivo/longueuil-1' element={<LeVivoLongueuil1/>}/>
          <Route path='/projets/hq' element={<Headquarters/>}/>
        </Routes>
        <Footer/>
         {/* Always render the cookie banner */}
         <CookieBanner />
      </ParallaxProvider>
    );
  }
  /*
}
*/


export default App;
